import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalSeeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_see"}/>
}
